// /* eslint-disable eslint-comments/disable-enable-pair */

import { takeLatest, put, all, call } from 'redux-saga/effects';

import BankDetailsActionTypes from './bank-details.types';
import {
	bankDetailsAdd,
	deleteBankDetails,
	fetchBankDetails,
	updateBankDetails,
} from './bank-details.service';

import {
	addBusinessBankSuccess,
	addBusinessBankFailure,
	addBusinessBankResponseChanged,
	fetchBusinessBankSuccess,
	fetchBusinessBankFailure,
	fetchBusinessBankResponseChanged,
	updateBusinessBankSuccess,
	updateBusinessBankFailure,
	updateBusinessBankResponseChanged,
	deleteBusinessBankFailure,
	deleteBusinessBankSuccess,
	deleteBusinessBankResponseChanged,
} from './bank-details.action';

import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import BankActionTypes from './bank-details.types';

/** *********************  START ADD BUSINESS BANK  ******************** */
export function* businessBankAdd({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName, bankListArr } = payload;
		const key = 'BusinessBankKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			CreatedBy: userID,
			DatabaseName: databaseName,
			BusinessBankList: bankListArr,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(bankDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addBusinessBankFailure(responseData.data));
		} else {
			yield put(addBusinessBankSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addBusinessBankFailure(error));
	}
}

export function* resetAddBusinessBankResponse() {
	yield put(addBusinessBankResponseChanged());
}

export function* onAddBusinessBankDetails() {
	yield takeLatest(BankActionTypes.ADD_BUSINESS_BANK_START, businessBankAdd);
}

export function* onAddBusinessBankResponseReset() {
	yield takeLatest(
		BankDetailsActionTypes.ADD_BUSINESS_BANK_RESPONSE_RESET,
		resetAddBusinessBankResponse,
	);
}
/** *********************  END ADD BUSINESS BANK ******************** */

/** *********************  START FETCH BUSINESS BANK  ******************** */
export function* businessBankFetch({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName } = payload;
		const key = 'GetBankDetailsKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			UserID: userID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchBankDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchBusinessBankFailure(responseData.data));
		} else {
			yield put(fetchBusinessBankSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBusinessBankFailure(error));
	}
}

export function* resetFetchBusinessBankResponse() {
	yield put(fetchBusinessBankResponseChanged());
}

export function* onFetchBusinessBankDetails() {
	yield takeLatest(BankActionTypes.FETCH_BUSINESS_BANK_START, businessBankFetch);
}

export function* onFetchBusinessBankResponseReset() {
	yield takeLatest(
		BankActionTypes.FETCH_BUSINESS_BANK_RESPONSE_RESET,
		resetFetchBusinessBankResponse,
	);
}
/** *********************  END FETCH BUSINESS BANK ******************** */

/** *********************  START UPDATE BUSINESS BANK  ******************** */
export function* businessBankUpdate({ payload }: any) {
	try {
		const { businessID, companyID, userID, databaseName, bankListArr } = payload;
		const key = 'UpdateBankDetailsKey';
		const jsonData = {
			BusinessID: businessID,
			CompanyID: companyID,
			CreatedBy: userID,
			DatabaseName: databaseName,
			BusinessBankList: bankListArr,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateBankDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateBusinessBankFailure(responseData.data));
		} else {
			yield put(updateBusinessBankSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateBusinessBankFailure(error));
	}
}

export function* resetUpdateBusinessBankResponse() {
	yield put(updateBusinessBankResponseChanged());
}

export function* onUpdateBusinessBankDetails() {
	yield takeLatest(BankActionTypes.UPDATE_BUSINESS_BANK_START, businessBankUpdate);
}

export function* onUpdateBusinessBankResponseReset() {
	yield takeLatest(
		BankActionTypes.UPDATE_BUSINESS_BANK_RESPONSE_RESET,
		resetUpdateBusinessBankResponse,
	);
}
/** *********************  END UPDATE BUSINESS BANK ******************** */

/** ********************* START UPDATE BUSINESS BANK ******************** */
export function* businessBankDelete({ payload }: any) {
	try {
		const { businessBankID, companyID, databaseName } = payload;
		const key = 'DeleteBusinessBankDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			BusinessBankID: businessBankID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(deleteBankDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteBusinessBankFailure(responseData.data));
		} else {
			yield put(deleteBusinessBankSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteBusinessBankFailure(error));
	}
}

export function* resetDeleteBusinessBankResponse() {
	yield put(deleteBusinessBankResponseChanged());
}

export function* onDeleteBusinessBankDetails() {
	yield takeLatest(BankActionTypes.DELETE_BUSINESS_BANK_START, businessBankDelete);
}

export function* onDeleteBusinessBankResponseReset() {
	yield takeLatest(
		BankActionTypes.DELETE__BUSINESS_BANK_RESPONSE_RESET,
		resetDeleteBusinessBankResponse,
	);
}
/** *********************  END DELETE BUSINESS BANK ******************** */

export function* bankDetailsSaga() {
	yield all([
		call(onAddBusinessBankDetails),
		call(onAddBusinessBankResponseReset),
		call(onFetchBusinessBankDetails),
		call(onFetchBusinessBankResponseReset),
		call(onUpdateBusinessBankDetails),
		call(onUpdateBusinessBankResponseReset),
		call(onDeleteBusinessBankDetails),
		call(onDeleteBusinessBankResponseReset),
	]);
}
